/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React from "react";
import { Button, ButtonGroup, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";

const BotonEstado = styled(Button)(({ theme, activecolor }) => ({
  textTransform: "none",
  color: "#fff",
  backgroundColor: activecolor || "#1a2035",
  borderColor: activecolor || "#1a2035",
  "&:hover": {
    backgroundColor: activecolor || "#1a2035",
  },
}));

const GrupoBotonesEstatus = ({ estatus, onSeleccion, validaArchivosGral = true }) => {
  const obtenerColor = (valor) => {
    switch (valor) {
      case 0:
        return estatus === 0 ? "#F58020" : "#1a2035";
      case 1:
        return estatus === 1 ? "#388e3c" : "#1a2035";
      case 2:
        return estatus === 2 ? "#d32f2f" : "#1a2035";
      default:
        return "#1a2035";
    }
  };

  return (
    <ButtonGroup disableElevation aria-label="Estatus de documento">
      <Tooltip title={validaArchivosGral ? "En revisión" : "En revisión"}>
        <BotonEstado activecolor={obtenerColor(0)} onClick={() => onSeleccion(0)}>
          {validaArchivosGral ? "En revisión" : "En revisión"}
        </BotonEstado>
      </Tooltip>
      <Tooltip title={validaArchivosGral ? "Validada" : "Cumple criterios"}>
        <BotonEstado activecolor={obtenerColor(1)} onClick={() => onSeleccion(1)}>
          {validaArchivosGral ? "Validada" : "Cumple criterios"}
          
        </BotonEstado>
      </Tooltip>
      <Tooltip title={validaArchivosGral ? "Rechazada" : "No cumple criterios"}>
        <BotonEstado activecolor={obtenerColor(2)} onClick={() => onSeleccion(2)}>
          {validaArchivosGral ? "Rechazada" : "No cumple criterios"}
          
        </BotonEstado>
      </Tooltip>
    </ButtonGroup>
  );
};

export default GrupoBotonesEstatus;
